class UploadHelper {
    constructor(element) {
        this.element = element
        this.id = this.element.id
        this.selectedFilesObj = document.createElement('div')
        this.selectedFilesObj.ariaAtomic = 'true'
        this.selectedFilesObj.classList = 'field__upload-helper-box'
        this.init()
    }

    init() {
        this.element.addEventListener('change', () => this.listSelectedFiles())
        this.element.insertAdjacentElement('afterend', this.selectedFilesObj)
    }

    listSelectedFiles() {
        const newUl = this.arrayToUnorderedList(this.element.files, 'name')
      
        this.selectedFilesObj.replaceChildren(newUl)
        this.element.files.length ? this.selectedFilesObj.insertAdjacentElement('afterbegin', this.resetUploadButton()) : null
    }

    arrayToUnorderedList(array, value) {
        const files = Object.keys(array)
        const ul = document.createElement('ul')
        ul.classList = 'field__upload-helper'
     
        files.map(key => {
            const li = document.createElement('li')
            li.textContent = array[key][value] ?? ''
            ul.appendChild(li)
        })
        return ul
    }

    resetUploadButton(){
        const button = document.createElement('button')
        button.innerText = 'Zurücksetzen'
        button.classList = 'drop-zone-reset'
        button.addEventListener('click', e => {
            this.element.value = ''
            this.listSelectedFiles()
        })
        return button
    }

}

export default UploadHelper